import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Loader2 } from 'lucide-react';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

interface LoadingSpinnerProps {
  size?: 'small' | 'large';
  text?: string;
  isFullPage?: boolean;
}

const SpinnerContainer = styled.div<{ size: 'small' | 'large' }>`
  display: inline-block;
  width: ${props => props.size === 'large' ? '40px' : '24px'};
  height: ${props => props.size === 'large' ? '40px' : '24px'};
  border: 3px solid ${props => props.theme.colors.gray200};
  border-radius: 50%;
  border-top-color: ${props => props.theme.colors.primary};
  animation: ${spin} 0.8s linear infinite;
  transition: opacity 0.3s ease-in-out;
`;

const Spinner = styled(Loader2)<{ $size: string }>`
  animation: spin 1s linear infinite;
  color: ${({ theme }) => theme.colors.primary};
  
  ${({ $size }) => {
    switch ($size) {
      case 'sm':
        return 'width: 20px; height: 20px;';
      case 'md':
        return 'width: 32px; height: 32px;';
      case 'lg':
        return 'width: 48px; height: 48px;';
      default:
        return 'width: 32px; height: 32px;';
    }
  }}

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: ${({ theme }) => theme.typography.base};
  margin: 0;
`;

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'small', 
  text,
  isFullPage = false
}) => {
  return (
    <SpinnerContainer size={size}>
      <Spinner $size={size} />
      {text && <LoadingText>{text}</LoadingText>}
    </SpinnerContainer>
  );
};

export default LoadingSpinner; 